import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './shared/routes/routes';
import { AppComponent } from './app.component';

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
